"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.matrix = initialState;
    }
    score = 0;
    status = "idle";
    static isGameActive = false;
    moveLeft() {
        const callback = (number)=>number !== 0;
        for(let arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++){
            const array = this.matrix[arrayIndex];
            const additionalArray = array.filter(callback);
            for(let i = 0; i < additionalArray.length; i++)if (additionalArray[i] === additionalArray[i + 1]) {
                const add = additionalArray[i] * 2;
                additionalArray[i] = add;
                additionalArray[i + 1] = 0;
                this.score += add;
            }
            const filteredArray = additionalArray.filter(callback);
            while(filteredArray.length - 1 < array.length - 1)filteredArray.push(0);
            this.matrix[arrayIndex] = filteredArray;
        }
        return this.matrix;
    }
    moveRight() {
        const callback = (number)=>number !== 0;
        for(let arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++){
            const array = this.matrix[arrayIndex];
            const additionalArray = array.filter(callback);
            for(let i = 0; i < additionalArray.length; i++){
                const lastElem = additionalArray.length - i - 1;
                if (additionalArray[lastElem] === additionalArray[lastElem - 1]) {
                    const add = additionalArray[lastElem] * 2;
                    additionalArray[lastElem] = add;
                    additionalArray[lastElem - 1] = 0;
                    this.score += add;
                }
            }
            const filteredArray = additionalArray.filter(callback);
            while(filteredArray.length - 1 < array.length - 1)filteredArray.unshift(0);
            this.matrix[arrayIndex] = filteredArray;
        }
        return this.matrix;
    }
    moveUp() {
        const callback = (number)=>number !== 0;
        for(let arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++){
            const columnElements = [];
            this.matrix.forEach((array, index)=>columnElements[index] = array[arrayIndex]);
            const filteredElements = columnElements.filter(callback);
            for(let i = 0; i < filteredElements.length; i++)if (filteredElements[i] === filteredElements[i + 1]) {
                const add = filteredElements[i] * 2;
                filteredElements[i] = add;
                filteredElements[i + 1] = 0;
                this.score += add;
            }
            const filteredArray = filteredElements.filter(callback);
            while(filteredArray.length - 1 < this.matrix[arrayIndex].length - 1)filteredArray.push(0);
            for(let index = 0; index < this.matrix.length; index++)this.matrix[index][arrayIndex] = filteredArray[index];
        }
    }
    moveDown() {
        const callback = (number)=>number !== 0;
        for(let arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++){
            const columnElements = [];
            this.matrix.forEach((array, index)=>columnElements[index] = array[arrayIndex]);
            const filteredElements = columnElements.filter(callback);
            for(let i = filteredElements.length - 1; i > 0; i--)if (filteredElements[i] === filteredElements[i - 1]) {
                const add = filteredElements[i] * 2;
                filteredElements[i] = add;
                filteredElements[i - 1] = 0;
                this.score += add;
            }
            const filteredArray = filteredElements.filter(callback);
            while(filteredArray.length - 1 < this.matrix[arrayIndex].length - 1)filteredArray.unshift(0);
            for(let index = 0; index < this.matrix.length; index++)this.matrix[index][arrayIndex] = filteredArray[index];
        }
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.matrix;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = "playing";
        return [
            this.addRandomElement(),
            this.addRandomElement()
        ];
    }
    restart() {
        this.matrix = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
        return this;
    }
    getRandomCoords() {
        let row = Math.floor(Math.random() * 4);
        let column = Math.floor(Math.random() * 4);
        while(this.matrix[row][column] !== 0){
            row = Math.floor(Math.random() * 4);
            column = Math.floor(Math.random() * 4);
        }
        return [
            row,
            column
        ];
    }
    addRandomElement() {
        return Math.random() < 0.1 ? 4 : 2;
    }
    isMovePossible() {
        const matrixLength = this.matrix.length;
        const matrix = this.matrix;
        for(let row = 0; row < matrixLength; row++)for(let column = 0; column < matrixLength; column++){
            if (column < matrixLength - 1 && matrix[row][column] === matrix[row][column + 1] || row < matrixLength - 1 && matrix[row][column] === matrix[row + 1][column]) return true;
        }
        return false;
    }
    isPlaying() {
        const zeros = this.matrix.filter((array)=>array.includes(0));
        const win = this.matrix.flat().includes(2048);
        if (!zeros.length && !this.isMovePossible()) this.status = "lose";
        if (win) this.status = "win";
        return this;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports([
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
]);
const $09e991522ca7e64e$var$container = document.querySelector(".container");
const $09e991522ca7e64e$var$gameHeader = $09e991522ca7e64e$var$container.querySelector(".game-header");
const $09e991522ca7e64e$var$controls = $09e991522ca7e64e$var$gameHeader.querySelector(".controls");
const $09e991522ca7e64e$var$button = $09e991522ca7e64e$var$controls.querySelector("button.button");
const $09e991522ca7e64e$var$gameScore = $09e991522ca7e64e$var$controls.querySelector(".game-score");
const $09e991522ca7e64e$var$tBody = $09e991522ca7e64e$var$container.querySelector("tbody");
const $09e991522ca7e64e$var$arrayOfTr = [
    ...$09e991522ca7e64e$var$tBody.querySelectorAll("tr")
];
const $09e991522ca7e64e$var$messages = $09e991522ca7e64e$var$container.querySelector(".message-container");
const $09e991522ca7e64e$var$startMessage = $09e991522ca7e64e$var$messages.querySelector(".message-start");
const $09e991522ca7e64e$var$loseMessage = $09e991522ca7e64e$var$messages.querySelector(".message-lose");
const $09e991522ca7e64e$var$winMessage = $09e991522ca7e64e$var$messages.querySelector(".message-win");
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        const values = $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startMessage.classList.add("hidden");
        $09e991522ca7e64e$var$button.classList.remove("start");
        $09e991522ca7e64e$var$button.classList.add("restart");
        $09e991522ca7e64e$var$button.textContent = "Restart";
        values.forEach((value)=>{
            const [row, column] = $09e991522ca7e64e$var$game.getRandomCoords();
            const cell = $09e991522ca7e64e$var$arrayOfTr[row].children[column];
            cell.textContent = value;
            cell.classList.add(`field-cell--${value}`);
            $09e991522ca7e64e$var$game.matrix[row][column] = value;
        });
    } else {
        [
            ...$09e991522ca7e64e$var$game.getState()
        ].forEach((array, index)=>{
            array.forEach((number, i)=>{
                const cell = $09e991522ca7e64e$var$arrayOfTr[index].children[i];
                cell.textContent = "";
                cell.className = "field-cell";
                if (number > 0) cell.classList.remove(`field-cell--${number}`);
            });
        });
        $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
        $09e991522ca7e64e$var$winMessage.classList.add("hidden");
        $09e991522ca7e64e$var$startMessage.classList.remove("hidden");
        $09e991522ca7e64e$var$button.classList.remove("restart");
        $09e991522ca7e64e$var$button.classList.add("start");
        $09e991522ca7e64e$var$button.textContent = "Start";
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$gameScore.textContent = `${$09e991522ca7e64e$var$game.getScore()}`;
    }
});
document.addEventListener("keydown", (EVENT)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    const key = EVENT.key;
    const prevState = JSON.stringify($09e991522ca7e64e$var$game.getState());
    if (key === "ArrowLeft") $09e991522ca7e64e$var$game.moveLeft();
    if (key === "ArrowRight") $09e991522ca7e64e$var$game.moveRight();
    if (key === "ArrowUp") $09e991522ca7e64e$var$game.moveUp();
    if (key === "ArrowDown") $09e991522ca7e64e$var$game.moveDown();
    const nextState = JSON.stringify($09e991522ca7e64e$var$game.getState());
    if (prevState !== nextState) {
        const randomElem = $09e991522ca7e64e$var$game.addRandomElement();
        if ($09e991522ca7e64e$var$game.matrix.flat().includes(0)) {
            const [row, column] = $09e991522ca7e64e$var$game.getRandomCoords();
            $09e991522ca7e64e$var$game.matrix[row][column] = randomElem;
            const cell = $09e991522ca7e64e$var$arrayOfTr[row].children[column];
            cell.textContent = randomElem;
            cell.classList.add(`field-cell--${randomElem}`);
        }
        $09e991522ca7e64e$var$game.isPlaying();
        if ($09e991522ca7e64e$var$game.matrix.flat().includes(0)) {
            const [row, column] = $09e991522ca7e64e$var$game.getRandomCoords();
            $09e991522ca7e64e$var$game.matrix[row][column] = randomElem;
            const cell = $09e991522ca7e64e$var$arrayOfTr[row].children[column];
            cell.textContent = randomElem;
            cell.classList.add(`field-cell--${randomElem}`);
        }
        $09e991522ca7e64e$var$game.isPlaying();
        const matrix = $09e991522ca7e64e$var$game.getState();
        matrix.forEach((array, rowIndex)=>{
            array.forEach((number, colIndex)=>{
                const cell = $09e991522ca7e64e$var$arrayOfTr[rowIndex].children[colIndex];
                cell.textContent = "";
                cell.className = "field-cell";
                if (number > 0) {
                    cell.textContent = number;
                    cell.classList.add(`field-cell--${number}`);
                }
            });
        });
        if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
        if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
    }
    $09e991522ca7e64e$var$gameScore.textContent = `${$09e991522ca7e64e$var$game.getScore()}`;
});


//# sourceMappingURL=index.3285fdab.js.map
